import { useIntl } from 'react-intl'
import { UrgencyPriorityRowDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { readablePriority } from '../../ServicesStatistics/periodDetail'
import { formatCount, formatMinutes } from '../urgencySummaryFormat'

interface UrgencyDayPrioritiesProps {
  rows: UrgencyPriorityRowDTO[]
}

/**
 * «Por código»: una fila por código de triaje con llegadas ese día (de más a menos urgente, «Sin código» al final), con las
 * llegadas y la espera media. Sin objetivos ni juicio: los objetivos de cada código son provisorios y se ven en la
 * pestaña «Por código de triaje».
 */
export default function UrgencyDayPriorities({ rows }: UrgencyDayPrioritiesProps) {
  const intl = useIntl()
  return (
    <ul className="nv-urg-detail__priorities">
      {rows.filter((row) => row.arrivals > 0).map((row) => (
        <li key={row.order} className="nv-urg-detail__priority">
          <span className="nv-urg-detail__name">{readablePriority(row.name)}</span>
          <span className="nv-urg-detail__meta">
            {intl.formatMessage({ id: 'UrgencySummaryWhereArrivals' }, { count: row.arrivals, countText: formatCount(intl, row.arrivals) })}
          </span>
          <span className="nv-urg-detail__minutes">{formatMinutes(intl, row.avgWaitMinutes)}</span>
        </li>
      ))}
    </ul>
  )
}
